export function createSelectOption(inValue: string | null | undefined): { id: string; label: string; value: string } {
  const value = inValue ?? '';

  return {
    id: value,
    label: value,
    value,
  };
}
